var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-detail"},[_c('div',[(_vm.detailInfo)?_c('desc-item',{attrs:{"mbBody":_vm.mbBody,"detailInfo":_vm.detailInfo}}):_vm._e()],1),(_vm.isshowBacktop)?_c('v-back-top',{attrs:{"target":_vm.target}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }